export default __webpack_public_path__ + "static/media/ras-al-khaimah.ba1a2821.svg";